import { FC, useContext } from "react";
import { FormView } from "@data-root/types";
import { Tabs } from "../../tabs";
import { resolveWrappedFormTabComponent } from "../../../utils";
import { InlineContext, InlineSingleRowProps } from "@data-root/react";

export const formTabStyles = {
  label: {
    fontSize: 12,
    fontWeight: "600",
    alignSelf: "center",
    alignItems: "center",
    textAlign: "center",
    color: "#515354",
    textTransform: "uppercase",
  },
};

export const InlineFormTabbedPresentation: FC<InlineSingleRowProps> = ({
  loaded,
}) => {
  const { table, view } = useContext(InlineContext)!;

  return (
    <Tabs
      table={table}
      view={view as FormView}
      resolver={resolveWrappedFormTabComponent}
    />
  );
};
